import { cn } from '@/lib/cn';

export type Bucket = 'Engaged' | 'Watching' | 'AtRisk' | 'Slipping';

const STYLES: Record<Bucket, string> = {
  Engaged: 'bg-bucket-engaged/10 text-bucket-engaged ring-bucket-engaged/30',
  Watching: 'bg-bucket-watching/10 text-bucket-watching ring-bucket-watching/30',
  AtRisk: 'bg-bucket-atrisk/10 text-bucket-atrisk ring-bucket-atrisk/30',
  Slipping: 'bg-bucket-slipping/10 text-bucket-slipping ring-bucket-slipping/30',
};

const LABELS: Record<Bucket, string> = {
  Engaged: 'Engaged',
  Watching: 'Watching',
  AtRisk: 'At Risk',
  Slipping: 'Slipping',
};

export function BucketBadge({ bucket, className }: { bucket: Bucket; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ring-1',
        STYLES[bucket],
        className,
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current"></span>
      {LABELS[bucket]}
    </span>
  );
}
